<template>
	<li data-component="group" ref="group">
		<group-header
			:expanded="expanded"
			:handleClick="expandAndScroll"
			:text="groupName"
			size="md"
		/>
		<transition name="expand">
			<div v-if="expanded" data-element="menu-element-container">
				<div v-for="(menuElement, elementIndex) in items" :key="elementIndex" data-element="menu-element">
					<sub-header v-if="menuElement.itemType === 'subHeader'" :text="menuElement.subHeader.text" />
					<text-field
						v-else-if="menuElement.itemType === 'textField'"
						:text="menuElement.textField.text"
						v-font-style="$store.getters['ui/getBodyCopyFontDetail']('light')"
					/>
					<product v-else-if="menuElement.itemType === 'product'"
						:product="menuElement.product"
						:getProduct="getProduct"
						:getCG="getCG"
						:cgIndex="cgIndex"
						:getKeyWord="getKeyWord"
						:addItemToBasket="addItemToBasket"
						:removeItemFromBasket="removeItemFromBasket"
						:getItemCount="getItemCount"
						:isVeg="isVeg"
						:isVegan="isVegan"
						:getMatchingBasketItemsChoicesAndPortions="getMatchingBasketItemsChoicesAndPortions"
						/>
				</div>
			</div>
		</transition>
	</li>
</template>

<script>

	import SubHeader from '@/components/menu/SubHeader';
	import TextField from '@/components/menu/TextField';
	import Product from '@/components/menu/Product';
	import GroupHeader from '@/components/menu/GroupHeader';
	import VueScrollTo from 'vue-scrollto';

	export default {
		props: [
			'items',
			'groupName',
			'getProduct',
			'getCG',
			'getKeyWord',
			'addItemToBasket',
			'removeItemFromBasket',
			'getItemCount',
			'cgIndex',
			'isVeg',
			'isVegan',
			'getMatchingBasketItemsChoicesAndPortions',
			'menuLabel'
		],
		components: {
			SubHeader,
			TextField,
			Product,
			GroupHeader
		},
		data () {
			return {
				expanded: false,
				windowWidth: 0,
				breakpoint: 992
			}
		},
		methods: {
			expandAndScroll () {
				if (this.windowWidth < this.breakpoint) {
					this.expanded = !this.expanded;
				}
				if (this.expanded) {
					VueScrollTo.scrollTo(this.$refs.group, 300, { offset: -56 })
				}
			}
		},
		watch: {
			menuLabel: function () {
				this.expanded = false;
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/assets/scss/variables.scss';
	@import '@/assets/scss/helpers.scss';

	[data-component='group'] {
		list-style:none;
		-webkit-tap-highlight-color:transparent;
		[data-element='menu-element-container'] {
			overflow:hidden;
			&.expand-enter-active, &.expand-leave-active {
				transition: max-height 0.2s linear;
				max-height:999px;
			}
			&.expand-enter, &.expand-leave-to /* .list-leave-active below version 2.1.8 */ {
				max-height:0;
			}
		}
	}
</style>
